import React,{useEffect} from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

function AgeGroupStats({agegroup}) {
    ChartJS.register(ArcElement, Tooltip, Legend);
    const data = {
        labels: ['Children','TeenAger','Adult','Senior Citizen','Other'],
        datasets: [
          {
            label: '# of Patient With',
            data: [agegroup.children,agegroup.teenager,agegroup.adult,agegroup.seniorCitizen,agegroup.other],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
             'rgba(153, 102, 255, 1)',
            ],
            borderWidth: 1,
          },
        ],
      };
  return (
    <>
    
    <div>Age Group</div>
    <Doughnut data={data}/>
</>
  )
}

export default AgeGroupStats